var body_styles = {
  body: {
    display: "flex",
    padding: "32px",
    flexDirection: "column" as const,
    alignItems: "center",
    gap: "32px",
    flex: "1 0 0",
    borderRadius: "8px",
    border: "1px solid var(--Gray---75, #F3F4F5)",
    background: "var(--White, #FFF)",
    width: "100%",
    paddingBottom: "100px"
  },
};

export default body_styles;
